import React from "react";
import styles from "./RefluxMonitoring.module.css";

/**
 * Panel shown while a DevTools monitor is off, with a button to turn it on.
 * Defaults describe Reflux monitoring; other tabs pass their own copy.
 * @param {Object} props
 * @param {Function} props.onEnable - Callback when enable button is clicked
 * @param {string} [props.title]
 * @param {string} [props.description]
 * @param {string} [props.buttonLabel]
 * @param {string} [props.testId]
 */
const EnableMonitoringPanel = ({
  onEnable,
  title = "Reflux Monitoring is disabled",
  description = "Enable monitoring to track store subscriptions, state changes, and action dispatches. This helps debug memory leaks and subscription issues.",
  buttonLabel = "Enable & Reload",
  testId,
}) => {
  return (
    <div className={styles.enableContainer} data-testid={testId}>
      <div className={styles.enableTitle}>{title}</div>
      <div className={styles.enableDescription}>{description}</div>
      <button type="button" className={styles.enableButton} onClick={onEnable}>
        {buttonLabel}
      </button>
    </div>
  );
};

export default EnableMonitoringPanel;
